import { render } from "./RiderList.vue?vue&type=template&id=a781c510&scoped=true"
import script from "./RiderList.vue?vue&type=script&lang=js"
export * from "./RiderList.vue?vue&type=script&lang=js"

import "./RiderList.vue?vue&type=style&index=0&id=a781c510&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a781c510"]])

export default __exports__